export const getApiBaseURLFromEnv = (): string | undefined => {
	const runtimeEnv = (window as any).__ENV__;
	const apiBaseURL =
		runtimeEnv?.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL;
	if (apiBaseURL === "")
		throw new Error(
			"REACT_APP_API_BASE_URL is not configured and could not be inferred",
		);
	return apiBaseURL;
};

export const getApiUrl = () => {
	try {
		const base = getApiBaseURLFromEnv() ?? "";
		const url = base.endsWith("/api/v1") ? base : `${base}/api/v1`;
		return url;
	} catch (e) {
		console.log("API Base URL is not configure {}", e);
		return "";
	}
};
